// @flow

import React from "react";
import missingThingsImage from "app/assets/missing-things.svg";
import "./NotFoundPage.scss";

const NotFoundPage = () => (
  <main className="not-found-page">
    <div className="not-found-page__tag">404 error</div>
    <h1>We can't find the page you asked for</h1>
    <p>Either the URL was mistyped or the page may no longer be available.</p>
    <p>
      If you think you've found something broken, please get in touch with the
      team on the
      <em>
        <a href="https://necpublishing.slack.com/archives/CPPFZV9TN">
          #prez-hub-feedback
        </a>
      </em>{" "}
      Slack channel.
    </p>
    <img src={missingThingsImage} alt="No content found" />
  </main>
);

export default NotFoundPage;
